module.exports = __webpack_public_path__ + "img/1.f28c6c51.jpg";